import './App.css';
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutCompany from "./components/AboutCompany";
import WhyChooseUs from "./components/WhyChooseUs";
import ProductsShowcase from "./components/ProductsShowcase";
import ContactDetails from "./components/ContactDetails";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <AboutCompany />
      <WhyChooseUs />
      <ProductsShowcase />
      <ContactDetails />
      <Footer />
    </div>
  );
}

export default App;
